// extracted by mini-css-extract-plugin
export default {"logo":"logoMobile_logo__lIROG"};